/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_chat_welcome = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `¡Hola ${i.name}! 👋`
};

const en_chat_welcome = /** @type {(inputs: { name: NonNullable<unknown> }) => string} */ (i) => {
	return `Hi ${i.name}! 👋`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ name: NonNullable<unknown> }} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const chat_welcome = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.chat_welcome(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("chat_welcome", locale)
	if (locale === "es") return es_chat_welcome(inputs)
	return en_chat_welcome(inputs)
};
export { chat_welcome as "chat.welcome" }